enum CacheTimes {
  FIFTEEN_MINUTES = 15 * 60 * 1000,
  ONE_HOUR = 60 * 60 * 1000,
  INFINITY = Infinity,
}

export default CacheTimes;
